module.exports = __webpack_public_path__ + "media/images/regions_old/Tahoua-b3150f3cf3fa167403b0ff89a7a64426.png";